import React, { useMemo } from 'react';
import moment from 'moment';
import ReviewStars from '../ReviewStars';
import resizeImage from '../../../utils/resizeImage';
import checkIsoDate from '../../../utils/checkIsoDate';
import Truncate from '../../Truncate';
import LazyLoad from '../../LazyLoad';
import ImageLightbox from '../../Lightbox/ImageLightbox';
import './styles.css';

const ReviewItem = ({
  review,
  showResponse,
  reviewAssets,
  lines,
  readMore,
}) => {
  const {
    message,
    displayName,
    createdAt,
    reviewResponse,
    rating,
    user,
    id,
  } = review;
  const { suburb = {} } = user || {};

  const assets = useMemo(
    () =>
      (reviewAssets || []).filter(({ reviewId }) => {
        return id === reviewId;
      }),
    [reviewAssets]
  );

  return (
    <div className="Review__ReviewItem__root">
      {/* {title && <h3 className="Review__ReviewItem__title">{title}</h3>} */}
      {rating && (
        <ReviewStars
          className="Review__ReviewItem__stars"
          countText={moment(createdAt).fromNow()}
          rating={rating}
          width={15}
        />
      )}
      {message && (
        <div className="Review__ReviewItem__comment">
          {lines ? (
            <Truncate lines={lines} ellipsis={readMore}>
              <span>{message}</span>
            </Truncate>
          ) : (
            message
          )}
        </div>
      )}
      {readMore}
      {displayName && (
        <div className="Review__ReviewItem__name">
          {displayName}
          {suburb && suburb.name ? ` - ${suburb.name}` : null}
        </div>
      )}
      {assets && !!assets.length && (
        <div className="Review__ReviewItem__images">
          <div className="Review__ReviewItem__list">
            <ImageLightbox
              name={`reviewImage${id}`}
              images={assets.map((image, key) => {
                return {
                  ...image,
                  sub: `${message ? `${message} -` : '-'} ${displayName}`,
                  children: (
                    <div className="Review__ReviewItem__image" key={key}>
                      <LazyLoad>
                        <img
                          src={resizeImage(image, {
                            width: '80',
                            height: '80',
                            fit: 'cover',
                          })}
                          alt=""
                        />
                      </LazyLoad>
                    </div>
                  ),
                };
              })}
            />
          </div>
          <span>
            {assets.length} photo{assets.length > 1 ? 's' : ''}
          </span>
        </div>
      )}
      {showResponse && reviewResponse && (
        <div className="Review__ReviewItem__responses">
          <div className="Review__ReviewItem__response">
            <h4 className="Review__ReviewItem__title">Owner&apos;s Response</h4>
            <div className="Review__ReviewItem__comment">
              {reviewResponse.message}
            </div>
            <div className="Review__ReviewItem__name">
              Business Owner{' '}
              {moment(checkIsoDate(reviewResponse.updatedAt)).fromNow()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewItem;
